<template>
    <div class="container">

        <div class="list-file">
            <div class="row list-file-item" v-for="(item, index) of listDataFile" :key="index">
                <div class="col-md-4" @click="handleOnViewFile(item)">
                    <h5><strong>{{ item.name }}</strong></h5>
                    <div class=" content-file">
                        <img class="icon-photo" src="@/assets/img/photo.png" />
                        &nbsp;&nbsp;
                        <div>
                            {{ item.fileName }}
                        </div>
                        &nbsp;&nbsp;
                        <div class="size-file">{{ formatSizeFile(item.sizeFile) }}</div>
                    </div>
                </div>
            </div>
            <div class="row pagination container m-0">
                <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
                    :per-page="paramQueryData.pageSize" first-number last-number></b-pagination>
            </div>
            <ModalViewFile v-if="isShowFile" :path="pathSelected" @closeModal="closeModalViewFile" />
        </div>
    </div>
</template>

<script>
import { listFileClassSchool } from './../../../_api/fileClassSchoolServices'
import ModalViewFile from './../../../_components/ModalViewFile'
export default {
    data() {
        return {
            paramQueryData: {
                lessonClassSchoolId: 0,
                keyword: '',
                pageIndex: 1,
                pageSize: 6,
                type: 2
            },
            listDataFile: [],
            totalRecords: 0,
            isShowFile: false,
            pathSelected: '',
        }

    },
    components: {
        ModalViewFile
    },
    watch: {
        'paramQueryData.pageIndex': 'getDataFile',
    },
    mounted() {
        this.paramQueryData.lessonClassSchoolId = this.$route.query.id
        this.getDataFile()
    },

    methods: {
        closeModalViewFile() {
            this.isShowFile = false
        },
        handleOnViewFile(file) {
            this.isShowFile = true
            this.pathSelected = file.path
        },
        getDataFile() {
            let self = this
            listFileClassSchool(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listDataFile = res.data.list
                    self.totalRecords = res.data.paging.totalRecords
                }
            })
        },
        formatSizeFile(data, to = 'MB') {
            const const_term = 1024;

            // Convert the values and concatenate 
            // the appropriate unit 
            if (to === "KB") {
                return (data / const_term).toFixed(3) + "KB";
            } else if (to === "MB") {
                return (data / const_term ** 2).toFixed(3) + "MB";
            } else if (to === "GB") {
                return (data / const_term ** 3).toFixed(3) + "GB";
            } else if (to === "TB") {
                return (data / const_term ** 4).toFixed(3) + "TB";
            } else {
                return "";
            }
        },
    }
}
</script>

<style scoped lang="scss">
.list-file-item img {
    width: 25px;
}

.list-file-item {
    margin-top: 10px;
}

.content-file {
    justify-content: space-between;
    display: flex;
    margin-top: 10px;
    align-items: baseline;
}

.size-file {
    font-size: 13px;
    color: gray;
}

.pagination {
    margin-bottom: 20px;
}
</style>